import { useQuery } from '@tanstack/react-query';
import { instagramQueries, instagram } from '@round/api';

const options = instagramQueries.timeSeries.options.list;

type Params = { audioId: number } & Pick<instagram.TimeSeriesRequestParams, 'start_date' | 'end_date'>;

export function useCreations({ audioId, start_date, end_date }: Params) {
    return useQuery({
        ...options({
            fields: ['posts_daily_change', 'posts_daily_totals'],
            ids: [audioId],
            type: 'audio',
            start_date: start_date,
            end_date: end_date,
        }),
        select: (data) => ({
            totals:
                data?.[audioId]?.posts_daily_totals.map((point) => ({
                    x: point.timestamp,
                    y: point.value,
                })) || [],
            daily:
                data?.[audioId]?.posts_daily_change.map((point) => ({
                    x: point.timestamp,
                    y: point.value,
                })) || [],
        }),
    });
}
